// ----------------------------------------------------------------------
const ROOTS = {
  AUTH: '/auth',
};

// ----------------------------------------------------------------------

type BuyerOrderDetailsParams =
  | { id: string; distributorId: string; distributorSiteId: string }
  | { id: string; distributorId?: undefined; distributorSiteId?: undefined };

export const paths = {
  // MAIN§
  main: {
    endUserLicenceAgreement: '/eula',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
  },
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: '/',
    userManagment: {
      root: '/user-managment',
      inviteUser: '/user-managment/invite-user',
      // TODO:  Might have to build a resolver funciton for more type safe routing
      editUser: (id: string) => `/user-managment/edit-user/${id}`,
    },
    buyerOrders: {
      root: '/buyer-orders',
      buyerOrderDetails: ({ id, distributorId, distributorSiteId }: BuyerOrderDetailsParams) => {
        if (distributorId && distributorSiteId) {
          return `/buyer-orders/${id}/${distributorId}/${distributorSiteId}`;
        }
        return `/buyer-orders/${id}`;
      },
    },
    products: {
      addProduct: '/add-product',
      editDraft: (id: string) => `/products/draft/${id}`,
      edit: (id: string) => `/products/${id}/edit`,
      details: (id: string) => `/products/${id}`,
      createProduct: '/products/create',
      root: '/products',
    },
    suppliers: {
      root: '/suppliers',
      addSupplier: '/suppliers/add',
      supplierDetails: (id: string) => `/suppliers/${id}`,
      supplierSiteDetails: (supplierOrgId: string, siteId: string) =>
        `/suppliers/${supplierOrgId}/sites/${siteId}`,
      supplierBulkProductTemplates: (id: string) => `/suppliers/${id}/bulk-product-templates`,
      supplierBulkProductPrices: (id: string) => `/suppliers/${id}/bulk-product-prices`,
      supplierBulkBespokePrices: (id: string) => `/suppliers/${id}/bulk-bespoke-prices`,
    },
    buyers: {
      root: '/buyers',
      addBuyer: '/buyers/add',
      buyerDetails: (id: string) => `/buyers/${id}`,
      editBuyerSite: (buyerOrgId?: string, buyerSiteId?: string) =>
        `/buyers/${buyerOrgId}/sites/${buyerSiteId}`,
    },
    user: {
      root: '/user',
      changePassword: '/user/change-password',
    },
    news: {
      root: '/news',
      addNewsPost: '/news/add',
      details: (id: string) => `/news/${id}`,
      viewNews: (id: string) => `/news/${id}/view`,
      editNews: (id: string) => `/news/${id}/edit`,
    },
    surplus: {
      root: '/surplus',
      editSurplusListing: (
        distributorOrgId?: string,
        distributorSiteId?: string,
        surplusEntityId?: string
      ) => `/surplus/edit/${distributorOrgId}/${distributorSiteId}/${surplusEntityId}`,
      addSurplusListing: (distributorOrgId?: string, distributorSiteId?: string) =>
        `/surplus/add/${distributorOrgId}/${distributorSiteId}`,
    },
    markers: {
      root: `/markers`,
      measuringMethods: `/markers/measuring-methods`,
      measuringMethodRequests: `/markers/measuring-methods/requests`,
      measurements: `/markers/measurements`,
    },
    seasonalCalendar: {
      root: `/seasonal-calendar`,
      addNewItem: `/seasonal-calendar/add`,
      editItem: (distributorOrgId: string, distributorSiteId: string, id: string) =>
        `/seasonal-calendar/${distributorOrgId}/${distributorSiteId}/${id}/edit`,
    },
    issues: {
      root: '/order-issues',
      issueDetails: (id: string) => `/order-issues/${id}`,
      anonymousReply: (id: string) => `/order-issues-email/${id}`,
      anonymousReplySuccess: '/order-issues-email/success',
    },
    invoices: {
      root: '/invoices',
      upload: '/invoices/upload',
      details: (id: string) => `/invoices/${id}`,
      pending: '/invoices/pending',
      analytics: '/invoices/analytics',
      edit: (id: string) => `/invoices/${id}/edit`,
      review: (id: string) => `/invoices/${id}/review`,
    },
    reporting: {
      root: '/reporting',
    },
    productsBulkActions: {
      root: (distributorId: string) => `/suppliers/${distributorId}/bulk-actions`,
      csvImportDetails: (distributorId: string, csvImportId: string) =>
        `/suppliers/${distributorId}/bulk-actions/${csvImportId}`,
    },
    priceBulkActions: {
      root: (distributorId: string) => `/suppliers/${distributorId}/price-bulk-actions`,
      csvImportDetails: (distributorId: string, csvImportId: string) =>
        `/suppliers/${distributorId}/price-bulk-actions/${csvImportId}`,
    },
    bespokePriceBulkActions: {
      root: (distributorId: string) => `/suppliers/${distributorId}/bespoke-price-bulk-actions`,
      csvImportDetails: (distributorId: string, csvImportId: string) =>
        `/suppliers/${distributorId}/bespoke-price-bulk-actions/${csvImportId}`,
    },
    stories: {
      root: '/stories',
    },
    dataMapper: {
      root: '/data-mapper',
      templateEdit: (orgId: string, templateId: string) => `/data-mapper/${orgId}/${templateId}`,
    },
  },
};
